define([
    "dojo/_base/declare",
    "dojo/_base/lang",
    "csi/def",
    "csi/def/Field",
    "csi/def/Relationship",
    "csi/form/Widget",
    "csi/xml"
], function(declare,lang,def,Field,Relationship,FormWidget,xml) {

    return declare(FormWidget, {
        _resolveView: function() {
            const inspectionNode = this.getFormData().getSource().getParent();
            
            const r = xml.isValidURL(inspectionNode.SamplingPlan) ? 
                                 {m_url: inspectionNode.SamplingPlan, m_id: "SamplingPlanAcceptanceLimits"}:
                                 {m_typeNode: "AcceptanceLimit"};

            this.defView.addField(lang.mixin(new Field(), {
                m_id : "AcceptanceLimit",
                m_typeControl : def.FIELD_FILTERING_SELECT,
                m_relationship : lang.mixin(new Relationship(), r)
            }));

            this.inherited(arguments);
        }
    });
});